<div class="bp-modal mod-lg wrapper">
  <bp-modal-header
		[title]="
			modalType === addressBookWalletViewType.WITHDRAW
				? ('send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name])
				: undefined
		"
    class="font-semibold">
    <button class="cancel-button" left (click)="back()" (keydown.enter)="back()" [tabIndex]="0">
      <strong>{{ "back" | translate }}</strong>
    </button>
    <button class="cancel-button" right (click)="cancel()" (keydown.enter)="cancel()" [tabIndex]="0">
      <strong>{{ "cancel" | translate }}</strong>
    </button>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-description">
      <div class="header">
        <h2>{{ modalTitle | translate }}</h2>
        <span class="title-description">
          {{ modalDescription | translate }}
        </span>
      </div>
    </div>

    <div class="bp-modal-body-section">
      <form [formGroup]="walletForm">
        <div class="inputs pb-15">
          <!-- Asset and Network Selection - Show for NEW and LEGACY wallet types -->
          @if(shouldShowAssetNetwork) {
            <div class="asset-network-pair mb-20 mt-20">
              <bp-select
                (selectedValueChange)="onAssetChange($event)"
                [useEmptyState]="true"
                [label]="'asset' | translate"
                [options]="assetOptions$ | async"
                [customSearchFn]="getCustomSearch()"
                [selectedValue]="asset.value"
                [disabled]="asset.disabled"
                [searchable]="true"
                [showDetails]="false"
                [placeholder]="'choose_an_asset' | translate"
                formControlName="asset"
                ngDefaultControl
                class="full-border">
              </bp-select>
              <bp-select
                (selectedValueChange)="onNetworkChange($event)"
                [useEmptyState]="true"
                [label]="'network' | translate"
                [options]="networkOptions$ | async"
                [disabled]="(networkOptions$ | async) === null || this.network.disabled"
                [selectedValue]="network.value"
                [showDetails]="false"
                [placeholder]="'choose_a_network' | translate"
                formControlName="network"
                ngDefaultControl
                class="full-border">
              </bp-select>
            </div>
          }

          <!-- Business Name / Full Legal Name -->
          <div class="form-group">
            <label
              class="form-label"
              [ngClass]="{ 'text-red': walletOwner.errors?.invalid_owner_name }"
              for="walletOwner">
              {{ ownerFieldLabel | translate }}
            </label>
            <input
              type="text"
              id="walletOwner"
              class="form-field mb-10"
              [ngClass]="{ 'mb-5 error-border': walletOwner.errors?.invalid_owner_name }"
              formControlName="walletOwner"
              [placeholder]="ownerFieldPlaceholder | translate" />
            @if (ownerFieldHint) {
              <span class="field-hint">{{ ownerFieldHint | translate }}</span>
            }
            @if(walletOwner.errors?.invalid_owner_name) {
              <span class="bpi__icon-close-round text-red font-size-11"> {{ walletOwnerError }}</span>
            }
          </div>

          <!-- The wallet belongs to me switch -->
          @if(shouldShowOwnWalletSwitch) {
            <bp-switch
              formControlName="ownWallet"
              ngDefaultControl
              (valueChange)="onOwnWalletChange($event)"
              field="ownWallet"
              class="mb-20">
              <span left>{{ ownWalletSwitchLabel | translate }}</span>
            </bp-switch>
          }

          <!-- Legal Entity Identifier (LEI) - Only for Legal Entity -->
          @if(shouldShowLegalEntityIdentifier) {
            <div class="form-group">
              <label
                class="form-label"
                [ngClass]="{ 'text-red': legalEntityIdentifier.errors?.invalid_lei }"
                for="legalEntityIdentifier">
                {{ "legal_entity_identifier" | translate }}
              </label>
              <input
                type="text"
                id="legalEntityIdentifier"
                class="form-field mb-10"
                [ngClass]="{ 'mb-5 error-border': legalEntityIdentifier.errors?.invalid_lei }"
                formControlName="legalEntityIdentifier"
                [placeholder]="legalEntityIdentifierPlaceholder" />
              @if(legalEntityIdentifier.errors?.invalid_lei) {
                <span class="bpi__icon-close-round text-red font-size-11"> {{ legalEntityIdentifierError }}</span>
              }
            </div>
          }

          <!-- Wallet Address -->
          <div class="form-group">
            <label
              class="form-label"
              [ngClass]="{ 'text-red': walletAddress.errors?.invalid_address }"
              for="walletAddress">
              {{ "wallet_addresses" | translate }}
            </label>
            <input
              type="text"
              id="walletAddress"
              class="form-field"
              [ngClass]="{ 'mb-5 error-border': walletAddress.errors?.invalid_address }"
              formControlName="walletAddress"
              [placeholder]="'wallet_addresses' | translate" />
            @if(walletAddress.errors?.invalid_address) {
              <span class="bpi__icon-close-round text-red font-size-11"> {{ walletAddressError }}</span>
            }
          </div>

          <!-- Wallet Host - Only show for Exchange wallets -->
          @if(shouldShowWalletHost) {
            <div class="form-group">
              <bp-select
                (selectedValueChange)="onWalletHostChange($event)"
                [label]="'wallet_host' | translate"
                [useEmptyState]="true"
                [searchable]="true"
                [selectedValue]="walletHost.value"
                [customSearchFn]="getHostSearch()"
                [options]="walletHosts$ | async"
                formControlName="walletHost"
                [placeholder]="'choose_a_host' | translate"
                ngDefaultControl
                class="full-border host-input">
              </bp-select>

              @if(walletHost?.value === "other"){
                <div class="form-group mt-15">
                  <label
                    class="form-label"
                    [ngClass]="{ 'text-red': otherHostName.errors?.invalid_host_hint }"
                    for="otherHostName">
                    {{ "host_name" | translate }}
                  </label>
                  <input
                    type="text"
                    id="otherHostName"
                    class="form-field"
                    [ngClass]="{ 'mb-5 error-border': otherHostName.errors?.invalid_host_hint }"
                    formControlName="otherHostName"
                    [placeholder]="'host_name' | translate" />
                  @if(otherHostName.errors?.invalid_host_hint) {
                    <span class="bpi__icon-close-round text-red font-size-11"> {{ hostHintError }}</span>
                  }
                </div>
              }
            </div>
          }

          <!-- Destination Tag (if needed) -->
          @if(shouldDisplayDestinationTag) {
            <div class="form-group">
              <label
                class="form-label"
                [ngClass]="{ 'text-red': destinationTag.errors?.invalid_destination_tag }"
                for="destinationTag">
                {{ destinationTagTextOptional }}
              </label>
              <input
                type="text"
                id="destinationTag"
                class="form-field"
                formControlName="destinationTag"
                [ngClass]="{ 'mb-5 error-border': destinationTag.errors?.invalid_destination_tag }"
                [placeholder]="destinationTagText" />
              @if(destinationTag.errors?.invalid_destination_tag) {
                <span class="bpi__icon-close-round text-red font-size-11"> {{ destinationTagError }}</span>
              }
            </div>
          }

          <!-- Self Declaration -->
        @if(shouldShowSelfDeclaration) {
          <bp-switch
            formControlName="selfDeclared"
            class="self-declared"
            ngDefaultControl
            (valueChange)="onSelfDeclaredChange($event)"
            field="selfDeclared">
            <span left>{{ "address_book_information_accuracy_toggle_message" | translate }}</span>
          </bp-switch>
        }

          <!-- Self-hosted wallet warning - LAST in the form -->
          @if(shouldShowSelfHostedWarning) {
            <div class="warning-container mt-25 padding-15">
              <p class="warning-title">{{ "wallet_may_require_validation_title" | translate }}</p>
              <p class="warning-description mb-15">
                {{ "address_book_self_hosted_warning_message" | translate }}
              </p>
              <a class="learn-more" [href]="learnMoreUrl" target="_blank">
                {{ "more_information" | translate }}
              </a>
            </div>
          }
        </div>

        <!-- Delete Wallet Section - Only show for LEGACY mode - ABOVE the save button -->
        @if(modalType === addressBookWalletViewType.LEGACY) {
          <div class="text-center">
            <a (click)="deleteWallet()" [tabIndex]="1" class="delete-wallet-link">
              {{ "delete_wallet" | translate }}
            </a>
          </div>
        }

        <!-- Save Button -->
        <button
          [disabled]="walletForm.invalid || (!SHW3rdPartyDisabled && !selfDeclared.value)"
          (click)="saveWallet()"
          type="submit"
          class="btn btn-primary save-wallet-btn">
          {{ (modalType === addressBookWalletViewType.NEW || modalType === addressBookWalletViewType.LEGACY ? "save_wallet" : "address_book_next") | translate }}
        </button>
      </form>
    </div>
  </div>
</div>